import tippy from 'tippy.js';

export class CopyLink {
    constructor() {
        this.set();
        this.init();
    }

    set() {}

    init() {
        window.addEventListener('click', async e => {
            const { target: eTarget } = e;
            const target = eTarget.closest('[data-copy-link]');
            if (!target) return;
            const copyLink = target.getAttribute('data-copy-link');

            if (!copyLink) return;

            if (navigator.clipboard) {
                await navigator.clipboard.writeText(copyLink);
            } else {
                this.fallback(copyLink);
            }

            this.showTooltip(target);
        });
    }

    showTooltip(el) {
        const instance = tippy(el, {
            content: phrases.copiedText,
            trigger: 'manual',
            placement: 'right',
            theme: 'copy',
        });

        instance.show();

        const remove = () => {
            instance.hide();
            setTimeout(() => {
                instance.destroy();
            }, 200);
            // el.removeEventListener('mouseleave', remove);
        };

        // el.addEventListener('mouseleave', remove);
        setTimeout(remove, 5000);
    }

    fallback(text) {
        const input = document.createElement('input');
        input.value = text;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        input.remove();
    }
}
